import { Outlet } from 'react-router-dom';
import LayoutBox from './LayoutBox';
import Main from './Main';
import BottomNav from './nav/BottomNav';
import { MapLoadingProvider } from '../loading/MapLoadingContext';

type BaseLayoutProps = {
  title?: string;
};

export default function BaseLayout({ title }: BaseLayoutProps) {
  return (
    <MapLoadingProvider>
      <Main>
        <LayoutBox>
          <Outlet />
        </LayoutBox>
        <BottomNav title={title} />
      </Main>
    </MapLoadingProvider>
  );
}
